module.exports = __webpack_public_path__ + "static/SquareSerif-Demi-webfont-1cb3c78abdfd7f1d9395fd9cf83a4b5c.ttf";